<template>
  <inner-view  class="column is-full" :show-shadow="stopAdmin" v-if="visible">
    <div v-if="visible">
      <div :class="{'box': !isModal}">
        <div class="panel-header">
          <div class="panel-title">서비스 운영 가이드</div>
          <i v-if="!isModal"
             class="icon-close material-icons unselect" @click="clickClose">close</i>
        </div>
        <div class="panel-content">
          <div class="grid-wrap" :style="`grid-template-columns:repeat(${list.length}, 1fr)`">
            <div v-for="(item, idx) in list" :key="`item-${idx}`" class="flex-column">
              <div class="size-14 weight-700" style="color:#363636;margin-bottom:8px">{{ item.title }}</div>
              <div class="guide-wrapper position-relative flex-column flex-1">
                <div class="flex-1">
                  <div class="flex unselect"
                       :style="{marginBottom: c_idx !== item.child.length - 1 ? '12px' : '0px'}"
                       v-for="(child, c_idx) in item.child"
                       :key="`child-${c_idx}`" @click="selectItem(child)">
                    <div class="circle" :class="{'selected-circle': child.selected}">
                      <img class="circle-checked" :class="{'svg-white': child.selected, 'svg-gray': !child.selected}"
                           :src="svgSrc('fi_check')">
                    </div>
                    <div style="flex:1;font-size:13px;margin-left:5px">{{ child.name }} <span v-if="child.require" class="size-11 weight-700 primary">*</span></div>
                  </div>
                </div>
                <div v-if="item.child.some(i => !i.selected)"
                     class="flex-end" style="margin-top:16px">
                  <div class="unselect size-13 weight-500" style="color:#787878" @click="clickJump(item)">단계 건너뛰기</div>
                </div>
                <div v-if="idx>0 && serviceInfo.plan && serviceInfo.plan.trial"
                     class="plan-wrapper">
                  <button class="button is-primary" @click="clickPlan">{{ accountName }}</button>
                </div>
              </div>
            </div>
          </div>

          <div class="flex-align size-12" style="margin-top:18px;color:#989898;gap:0 4px">
            <img :src="svgSrc('u_exclamation-circle')">
            <span class="size-11 weight-700 primary">*</span>필수사항을 입력하지 않으면 서비스가 제대로 작동하지 않을 수 있습니다.
          </div>
        </div>
      </div>
    </div>
  </inner-view>
</template>
<script>
  import InnerView from "../../layout/InnerView";
  export default {
    name: "ServiceGuide",
    components: {InnerView},
    props: {
      isModal: {
        type: Boolean,
        default: false
      }
    },
    created() {
      this.setPluginGuide();
    },
    data() {
      return {
        list: [
          {
            title: '기본 설정하기',
            child: [
              {
                id: 'basic',
                name: '기본 정보 등록하기',
                path: 'service/info',
                selected: false,
                reqSave: true
              },

              {
                id: 'design',
                name: '디자인 편집하기',
                path: '/developers/ui/builder',
                selected: false,
                reqSave: false
              },
              {
                id: 'partner',
                name: '판매자 등록하기',
                path: 'partner/create',
                selected: false,
                reqSave: true
              },
              {
                id: 'product',
                name: '상품 등록하기',
                path: 'product/create',
                selected: false,
                reqSave: true
              },
              {
                id: 'policy',
                name: '서비스 약관 등록하기',
                path: 'service/policy',
                selected: false,
                reqSave: true
              },
              {
                id: 'pay',
                name: '결제 기능 연동하기',
                path: 'service/setting',
                require: true,
                selected: false,
                reqSave: true
              },
            ]
          },
          {
            title: '운영하기',
            child: [
              {
                id: 'domain',
                name: '도메인 연동하기',
                path: 'https://platformfy.com/market/detail?id=155',
                selected: false,
                reqSave: false
              },
              {
                id: 'map',
                name: '지도 API 연동하기',
                require: true,
                path: 'service/account?menu=naver',
                selected: false,
                reqSave: true
              },
              {
                id: 'email',
                name: '메일발송 설정하기',
                require: true,
                path: 'service/account?menu=google',
                selected: false,
                reqSave: true
              },
              {
                id: 'sns',
                name: '소셜 로그인 설정하기',
                require: false,
                path: 'https://platformfy.com/market/detail?id=170',
                selected: false,
                reqSave: false
              },

            ]
          },
          {
            title: '서비스 키우기',
            child: [
              {
                name: 'GA 연동하기',
                path: 'https://platformfy.com/market/detail?id=153',
                selected: false,
                reqSave: false
              },
              {
                id: 'sms',
                name: 'SMS 발송하기',
                path: 'service/account?menu=sms',
                selected: false
              },
              {
                name: '앱 만들기',
                path: 'https://platformfy.com/notice/detail?id=11',
                selected: false
              },
              {
                name: '채널톡 신청하기',
                path: 'https://platformfy.com/market/detail?id=139',
                selected: false
              },
            ]
          },
        ]
      }
    },
    computed: {
      accountName() {
        return `${this.serviceInfo.service_type === 4 ? '플랜' : '스킨'} 결제`
      },
      visible() {
        // 모두 체크된 경우 비노출
        return this.$store.getters.dashboardPanel.visible.guide &&
          this.list.some(i => i.child.some(j => !j.selected));
      },
    },
    watch: {
      visible(n) {
        if(!n) {
          let panel = this.$store.getters.dashboardPanel;
          panel.visible.guide = false;
          this.$store.commit('setDashboardPanel', panel);
        }
        this.$emit('onSelected', n);
      }
    },
    methods: {
      clickPlan() {
        this.$root.$emit('planChangeModal');
      },
      clickJump(item) {
        item.child.forEach(i => {
          i.selected = true;
        });
        this.$axios.post('admin/service/guide/save', {
          names: item.child.map(i => i.name)
        })
      },
      addPluginMenu(menu, key, name, path) {
        if (this.isInternalPlugin(key)) {
          menu.push({
            id: key,
            name: name,
            path: path,
            selected: false
          });
        }
        return menu;
      },
      addMenu(menu, key, name, path) {
        menu.push({
          id: key,
          name: name,
          path: path,
          selected: false
        });
        return menu;
      },
      async setPluginGuide() {
        let menu = [];
        // 서비스 가이드
        menu = this.addPluginMenu(menu, 'guide', '서비스 가이드 설정하기', 'guide');
        // 회원등급
        menu = this.addPluginMenu(menu, 'user_grade', '회원 등급 설정하기', 'user/grade');
        // 파트너등급
        menu = this.addPluginMenu(menu, 'partner_grade', '파트너 등급 설정하기', 'partner/grade');
        // 공지사항 팝업
        menu = this.addPluginMenu(menu, 'popup', '공지사항 팝업 설정하기', 'popup');
        // 쿠폰/적립금
        menu = this.addPluginMenu(menu, 'point_coupon', '쿠폰 설정하기', 'coupon');
        menu = this.addPluginMenu(menu, 'point_coupon', '적립금 설정하기', 'point/setting');
        // 본인인증, 성인인증
        menu = this.addPluginMenu(menu, 'nice_identity_verify', '본인확인 서비스 연동하기', 'service/account?menu=verify');
        menu = this.addPluginMenu(menu, 'age_verify', '본인확인 서비스 연동하기', 'service/account?menu=verify');
        // 파트너 기획전
        menu = this.addPluginMenu(menu, 'partner_exhibition', '파트너 기획전 설정하기', 'exhibition_partner');
        // 파트너별 상품 기획전
        menu = this.addPluginMenu(menu, 'partner_product_exhibition', '파트너별 상품 기획전 설정하기', 'exhibition_partner_product');

        /* 추가서비스 체크 */
        let admin = this.$store.getters.admin;
        try {
          let res = await this.$axios.get(`https://master-dev.launchpack.co.kr:1111/serviceadmin/${admin.id}/launchpack/service/${this.serviceInfo.id}/app_order?category=49`,
            {headers: {Authorization: `Token ${admin.token}`}});
          if (res.status === 200) {
            res.data.forEach(item => {
              // 신청 또는 이용중일 때
              if (2 >= item.status) {
                if (item.product.name.indexOf('GA') > -1) {
                  menu = this.addMenu(menu, 'ga', '구글 애널리틱스 추적 ID 설정하기', 'service/account?menu=google');
                } else if (item.product.name.indexOf('콘텐츠 스토리지') > -1) {
                  menu = this.addMenu(menu, 'ga', '아마존웹서비스 스토리지 연동하기', 'service/account?menu=aws');
                }
              }

            });
          }
        } catch (e) {
          console.log(e);
        }


        if (!this.serviceInfo.plan.trial && menu.length > 0) {
          this.list.push({
            title: '기능추가 완료하기',
            child: menu
          })
        }
        try {
          let res = await this.$axios.get('admin/service/guide');
          if(res.data.length===0) {
            this.$axios.post('admin/service/guide', this.list)
          } else {
            let selected_list = res.data;
            if(Array.isArray(selected_list)) {
              selected_list.forEach(s_item=>{
                s_item.child.forEach(child=>{
                  if(child.selected) {
                    this.list.forEach(item=>{
                      let data = find(item.child, 'name', child.name)
                      if(data) data.selected = true;
                    })
                  }
                })
              })
            }
          }
        } catch (e) {
          console.log(e);
        }

        let result = this.list.some(i => i.child.some(j => !j.selected));
        this.$emit('onSelected', result);
      },
      clickClose() {
        let panel = this.$store.getters.dashboardPanel;
        panel.visible.guide = false;
        this.$store.commit('setDashboardPanel', panel);
      },
      selectItem(item) {
        if (!item.reqSave && !item.require && !item.selected) {
          item.selected = true;
          this.$store.commit('setServiceGuideList', this.list);
          this.$axios.post('admin/service/guide', this.list);
        }

        if (item.path.indexOf('ui/builder') > -1) {
          this.saveServiceGuide('design')
          window.open(item.path, '_blank');
        } else if (item.path.indexOf('market') > -1) {
          if(this.serviceInfo.service_type === 5) {
            this.routerPush('/office/admin/launchpack/inquiry/customer/create?cat=3');
          } else {
            let id = item.path.split('?id=')[1];
            this.$root.$emit('appMarket', {
              detail: id
            })
          }
        } else if (item.path.indexOf('notice') > -1) {
          window.open(item.path, '_blank');
        } else {
          this.routerPush(`/office/admin/${item.path}`);
        }
      }
    }
  }
</script>
<style lang="stylus" scoped>
  @import '~assets/css/lp_main'
  .box
    padding 0

  .panel-header
    padding 16px 20px
    display flex
    align-items center
    justify-content space-between
    border-bottom 1px solid #eeeeee

  .panel-title
    color $main
    font-size 21px
    font-weight 300

  .icon-close
    color rgba(0, 0, 0, 0.54)
    margin-left 16px

  .panel-content
    padding 20px

  .guide-wrapper
    background-color $gray3
    border-radius 6px
    padding 16px 12px
    height 100%
    overflow hidden

  .circle
    margin-top 2px
    border 1px solid #b6becb
    background-color white
    width 16px
    height 16px
    border-radius 50%
    position relative

  .selected-circle
    background-color $primary
    border none

  .circle-checked
    width 12px
    height 12px
    position absolute
    top 50%
    left 50%
    transform translate(-50%, -50%)

  .grid-wrap
    display grid
    grid-template-columns repeat(3, 1fr)
    grid-column-gap 16px

  .plan-wrapper
    position absolute
    width 100%
    height 100%
    z-index 1
    top 0
    left 0
    background-color rgba(0,0,0,0.3)
    display flex
    align-items center
    justify-content center
    .button
      width 87px
      height 36px
</style>
